import React from 'react';
import {onDownloadStart} from "../services/Statistics";

const url='https://s3.eu-central-1.amazonaws.com/naura-builds/';
export default ({data})=>(data ?<div className='download--container'>
        <div className='download-description'>
            <h4 className='fill'>{data.title}</h4>
            <p className='fill'>{data.whatsnew}</p>
        </div>
        <button className='download--button' onClick={()=>{onDownloadStart({source:'downloads page', link:url+data.key})}}>
            <a href={url+data.key} download target='_blank'>
               Скачать
            </a>
        </button>
    </div>:null);